const events = require("./reportEvents.js");

const defaultReportDataState = {
    Data: null,
    Loading: false,
    Error: null
}; 

const reportHandlers = {
    [events.RegionSelectionsChanged.Name](prev, event) {
        const update = {
            Reports: Object.assign({}, prev.Reports, {
                SelectedAudit: event.Audit,
                SelectedDivision: event.Division,
                SelectedDistrict: event.District,
                DateRange: event.DateRange,
                CompletedAudits: defaultReportDataState
            })
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.AuditSelectionChanged.Name](prev, event) { 
        const update = { 
            Reports: Object.assign({}, prev.Audit, { 
                SelectedAudit: event.Name,
                SelectedDivision: prev.SelectedDivision,
                SelectedDistrict: prev.SelectedDistrict,
                CompletedAudits: defaultReportDataState
            })
        }; 

        const result = Object.assign({}, prev, update); 

        return result; 
    },
    [events.CompletedAuditsLoading.Name](prev, event) {
        const update = {
            Reports: Object.assign({}, prev.Reports, {
                CompletedAudits: {
                    Data: null,
                    Loading: true,
                    Error: null
                }
            })
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.CompletedAuditsLoaded.Name](prev, event) {
        const update = {
            Reports: Object.assign({}, prev.Reports, {
                CompletedAudits: {
                    Data: event.Data,
                    Loading: false,
                    Error: null
                }
            })
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.CompletedAuditsErrored.Name](prev, event) {
        const update = {
            Reports: Object.assign({}, prev.Reports, {
                CompletedAudits: {
                    Data: null,
                    Loading: false,
                    Error: event.Error
                }
            })
        };

        const result = Object.assign({}, prev, update);

        return result;
    }, 
    [events.GetValidAuditPeriods.Name](prev, event) { 
        const update = { 
            AuditPeriods: null
        }; 

        const result = Object.assign({}, prev, update); 

        return result; 
    }, 
    [events.GotValidAuditPeriods.Name](prev, event) { 
        const update = {
            AuditPeriods: event.Data
        }; 

        const result = Object.assign({}, prev, update); 

        return result; 
    }, 
    [events.ErroredValidAuditPeriods.Name](prev, event) { 
        const update = { 
            AuditPeriods: "Error Retrieving Data"
        };

        const result = Object.assign({}, prev, update); 

        return result; 
    },
    [events.ClearCompletionReport.Name](prev, event) { 
        const update = {
            CompleteReport: null
        };

        const result = Object.assign({}, prev, update);

        return result; 
    }, 
    [events.GetCompletionReport.Name](prev, event) {
        const update = {
            CompleteReport: null
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.GotCompletionReport.Name](prev, event) {
        const update = {
            CompleteReport: Object.assign({}, prev.CompleteReport, {
                Division: event.Data.Division,
                Districts: event.Data.Districts,
                StoreCount: event.Data.StoreCount,
                AuditCount: event.Data.AuditCount,
                AuditTypeName: event.Data.AuditTypeName,
                NinetyDayCount: event.Data.NinetyDayCount
            })
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.ErroredGetCompletionReport.Name](prev, event) {
        const update = {
            CompleteReport: null
        };

        const result = Object.assign({}, prev, update);

        return result; 
    },
    [events.LoadingCompleteReport.Name](prev, event) {
        const update = {
            LoadingCompleteReport: event.Data
        };

        const result = Object.assign({}, prev, update);

        return result; 
    },
    [events.GetDistrictReport.Name](prev, event) {
        const update = {
            DistrictReport: null
        };

        const result = Object.assign({}, prev, update);

        return result;
    },
    [events.GotDistrictReport.Name](prev, event) {
        const update = {
            DistrictReport: Object.assign({}, prev.DistrictReport, {
                Stores: event.Data
            })
        };

        const result = Object.assign({}, prev, update);

        return result; 
    },
    [events.ErroredGetDistrictReport.Name](prev, event) {
        const update = {
            DistrictReport: null
        };

        const result = Object.assign({}, prev, update);

        return result; 
    }
};

module.exports = reportHandlers;


// WEBPACK FOOTER //
// ./src/events/reports/reportHandlers.js